import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './sessions.constants';
import * as types from './sessions.types';
import * as services from './sessions.saga-services';

function* invokeUpdateSession(action: types.IUpdateSession) {
  yield call(services.updateSessions, action.payload.id, action.payload.data);
}

function* invokeSaveSessionSocket(action: types.ISaveSessionSocket) {
  yield call(services.handleSaveSessionFromSocket, action.payload.id, action.payload);
}

function* invokeDeleteSession(action: types.IDeleteSession) {
  yield call(services.deleteSession, action.payload);
}

function* invokeDeleteSessionSocket(action: types.IDeleteSessionSocket) {
  yield call(services.handleDeleteSessionFromSocket, action.payload);
}

function* invokeSaveEmail(action: types.ISaveEmail) {
  yield call(services.saveEmail, action.payload.id, action.payload.email);
}

function* invokeSaveEmailSocket(action: types.ISaveEmailSocket) {
  yield call(services.handleEmailFromNotification, action.payload);
}

export function* watchSessionsPageSaga() {
  yield takeLatest(constants.UPDATE_SESSION, invokeUpdateSession);
  yield takeLatest(constants.SAVE_SESSION_SOCKET, invokeSaveSessionSocket);
  yield takeLatest(constants.DELETE_SESSION, invokeDeleteSession);
  yield takeLatest(constants.DELETE_SESSION_SOCKET, invokeDeleteSessionSocket);
  yield takeLatest(constants.SAVE_EMAIL, invokeSaveEmail);
  yield takeLatest(constants.SAVE_EMAIL_SOCKET, invokeSaveEmailSocket);
}
